import { useState, useCallback, useEffect } from 'react';
import { ChatApiService, type MyChatItem } from '../api/chat';

const chatApiService = new ChatApiService();

export interface UseChatListReturn {
  items: MyChatItem[];
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export function useChatList(sidebarOpen: boolean, isAuthenticated: boolean): UseChatListReturn {
  const [items, setItems] = useState<MyChatItem[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchChats = useCallback(async () => {
    if (!isAuthenticated) return;
    setIsLoading(true);
    setError(null);
    try {
      const list = await chatApiService.getMyChats();
      setItems(list);
    } catch (e) {
      const message = e instanceof Error ? e.message : 'Не удалось загрузить список чатов';
      setError(message);
      setItems([]);
    } finally {
      setIsLoading(false);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (!isAuthenticated) {
      setError(null);
      setItems([]);
      setIsLoading(false);
      return;
    }
    fetchChats();
  }, [isAuthenticated, fetchChats]);

  useEffect(() => {
    if (isAuthenticated && sidebarOpen) {
      fetchChats();
    }
  }, [isAuthenticated, sidebarOpen, fetchChats]);

  return { items, isLoading, error, refetch: fetchChats };
}
